interface ErrorMessageProps {
  name?: string
  message: string
}

export const ErrorMessage = ({ name, message }: ErrorMessageProps) => {
  return (
    <span
      data-testid={`${name ? `${name.replace(/\./g, '_')}_error_message` : ''}`}
      className="text-sm text-danger-soft"
    >
      {message}
    </span>
  )
}
